import { getOfflineDb } from '../../offline/dbFactory'
import type { EntityOutboxEntry } from '../../offline/db'

// Findings #123 (rehearsal 2): when the server refuses a crew record for lack
// of permission (403), the phone only said "Error al sincronizar" and
// Reintentar did nothing visible. The record stays queued on the phone; the
// crew needs to know it is a permission problem for the office to fix.
// `lastError === 'Forbidden'` also catches entries that failed before
// `lastErrorStatus` was stored.
export const isPermissionBlockedEntry = (entry: Pick<EntityOutboxEntry, 'lastError' | 'lastErrorStatus'>): boolean => (
  entry.lastErrorStatus === 403 || /^forbidden$/i.test((entry.lastError ?? '').trim())
)

export const readCrewPermissionBlocked = async (): Promise<boolean> => {
  try {
    const entries = await getOfflineDb().entityOutbox.toArray()
    return entries.some(isPermissionBlockedEntry)
  } catch {
    return false
  }
}
